import { ApolloError, useQuery } from '@apollo/client'
import { GetCurrencyConversionsByEmployeeQuery, GetCurrencyConversionsByEmployeeQueryVariables } from '../../../types'
import { CURRENCY_CONVERSIONS_BY_EMPLOYEE } from '../CurrencyConversionQueries'

export const useCurrencyConversionsByEmployee = (
  employeeId: string,
): { data: GetCurrencyConversionsByEmployeeQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, loading, error } = useQuery<GetCurrencyConversionsByEmployeeQuery, GetCurrencyConversionsByEmployeeQueryVariables>(
    CURRENCY_CONVERSIONS_BY_EMPLOYEE,
    {
      variables: {
        employeeId,
      },
      fetchPolicy: 'cache-and-network',
    },
  )

  return { data, loading, error }
}
